import { ROUTES } from "../data";

export default function Tools() {
  const tools = ROUTES.flatMap((g) => g.tools);

  return (
    <div className="max-w-4xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Tools</h1>
      <p className="text-gray-500 mb-8">All MCP tools exposed by the Jobego connector. Claude can invoke any of these once authorized.</p>

      <ul className="space-y-2">
        {tools.map((tool) => (
          <li key={tool.name} className="text-sm">
            <code className="font-mono font-bold text-gray-900">{tool.name}</code>
            <span className="text-gray-500"> — {tool.description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
